<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <dependents-form>
            </dependents-form> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import dependentsForm from './todo-dependents-form'
export default {
    components: {
        dependentsForm
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-dependents-form.vue